import React, { useState, useEffect, useRef } from 'react';
import parse from 'html-react-parser';
//import { useLocation } from 'react-router-dom';
import './Footer.css';

import { language } from '../WEBContent/Language';

import { repo_img_link, content_language, translate, compose_link_nl } from '../../../Utils';

//import * as Hosts from '../../../Hosts';

//import { facebook } from "@fortawesome/free-solid-svg-icons";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const Footer = (props) => {

  const [, set_dados] = useState(null)
	const dados_config = useRef({})

  const [lang, set_lang] = useState(localStorage.getItem('lang'));
  const [, set_lang_id] = useState('1');

  //const location = useLocation().pathname;

  const [color_primary, set_color_primary] = useState('');

  const data_interface_navbar = {
    id: '',
    info: {},
    content: {
      childs: []
    }
  }

  const navbar = useRef(data_interface_navbar);

  const [isloading, setLoading] = useState(true);

  useEffect(() => {
  
    if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
      set_dados(navbar.current = props.dados_navbar)
    }

    if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
      set_dados(dados_config.current = props.dados_config)

      set_color_primary(dados_config.current.info.theme.info.color.primary)
    }

    if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
      set_lang('pt')
      set_lang_id('1')

      setLoading(false)
    }
    else {
      set_lang(localStorage.getItem('lang'))
      content_language.forEach(el => {
        if (el.code === localStorage.getItem('lang')) {
          set_lang_id(el.id)
        }
      })

      setLoading(false)
    }

  }, [props])
  
  //const page_location = useLocation().pathname.split('/').pop();

  return isloading ?
    null
  :
    <table cellPadding="0" cellSpacing="0" align="center" className="es-content nvnl" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', width: '100%', tableLayout: 'fixed !important' }} >
      <tbody>
        <tr style={{borderCollapse: 'collapse'}} >
          <td>
            <table cellPadding="0" cellSpacing="0" align="center" className="es-footer" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', width: '100%', tableLayout: 'fixed !important', backgroundColor: 'transparent', backgroundRepeat: 'repeat', backgroundPosition: 'center top' }} >
              <tbody>
                <tr style={{ borderCollapse: 'collapse' }}>
                  <td bgcolor="#efefef" align="center" style={{padding: '0', margin: '0', backgroundColor: '#efefef' }} >
                    <table cellSpacing="0" cellPadding="0" align="center" bgcolor="#e5e4e4" className="es-footer-body" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', backgroundColor: '#e5e4e4', width: '600px' }} role="none">
                      <tbody>
                        <tr style={{ borderCollapse: 'collapse' }}>
                          <td style={{ padding: '15px', margin: '0' }}>
                            <table width="100%" cellSpacing="0" cellPadding="0" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }}>
                              <tbody>
                                <tr style={{ borderCollapse: 'collapse' }}>
                                  <td valign="top" align="center" style={{ padding: '0', margin: '0', width: '570px' }} >
                                    <table width="100%" cellSpacing="0" cellPadding="0" role="presentation" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }}>
                                      <tbody>
                                        <tr style={{ borderCollapse: 'collapse' }}>
                                          <td align="center" style={{ padding: '0', margin: '0', paddingBottom: '5px' }}>
                                            <h3 style={{ margin: '0', fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'", msoLineHeightRule: 'exactly', letterSpacing: '0', fontSize: '16px', fontStyle: 'normal', fontWeight: 'normal', lineHeight: '24px', color: '#333333' }}>
                                              <strong>{translate(dados_config.current.content[0].company, 'pt')}</strong>
                                            </h3>
                                          </td>
                                        </tr>
                                        <tr style={{ borderCollapse: 'collapse' }}>
                                          <td align="center" style={{ padding: '0', margin: '0' }}>
                                            <p style={{ margin: '0', fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'", msoLineHeightRule: 'exactly', lineHeight: '21px', letterSpacing: '0', color: '#333333', fontSize: '13px' }} >
                                              {
                                              dados_config.current.content[0].contacts.address !== undefined && dados_config.current.content[0].contacts.address !== null && dados_config.current.content[0].contacts.address !== '' ?
                                                <span>
                                                  {parse(dados_config.current.content[0].contacts.address)}
                                                </span>
                                              :
                                                null
                                              }
                                            </p>
                                          </td>
                                        </tr>
                                        <tr style={{ borderCollapse: 'collapse' }}>
                                          <td align="center" style={{ padding: '0', margin: '0', paddingBottom: '10px' }}>
                                            <p style={{ margin: '0', fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'", msoLineHeightRule: 'exactly', lineHeight: '21px', letterSpacing: '0', color: '#333333', fontSize: '13px' }} >                                               
                                              {
                                              dados_config.current.content[0].contacts.tlf !== undefined && dados_config.current.content[0].contacts.tlf !== null && dados_config.current.content[0].contacts.tlf !== '' ?
                                                <span>Tlf.: {dados_config.current.content[0].contacts.tlf} | </span>
                                              :
                                                null
                                              } 
                                              {
                                              dados_config.current.content[0].contacts.tlm !== undefined && dados_config.current.content[0].contacts.tlm !== null && dados_config.current.content[0].contacts.tlm !== '' ?
                                                <span>Tlm.: {dados_config.current.content[0].contacts.tlm} | </span>
                                              :
                                                null
                                              } 
                                              {
                                              dados_config.current.content[0].contacts.email !== undefined && dados_config.current.content[0].contacts.email !== null && dados_config.current.content[0].contacts.tlemail !== '' ?
                                                <span>Email: <a href={'mailto:' + dados_config.current.content[0].contacts.email} style={{color: color_primary}} target="_blank">{dados_config.current.content[0].contacts.email}</a></span>
                                              :
                                                null
                                              } 
                                            </p>
                                          </td>
                                        </tr>
                                        {
                                        dados_config.current.content[0].contacts.link !== undefined && dados_config.current.content[0].contacts.link !== null && dados_config.current.content[0].contacts.link !== '' ?
                                          <tr style={{ borderCollapse: 'collapse' }}>
                                            <td align="center" style={{ padding: '0', margin: '0', paddingBottom: '10px' }}>
                                              <p style={{ margin: '0', msoLineHeightRule: 'exactly', fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'", lineHeight: '21px', letterSpacing: '0', color: '#333333', fontSize: '13px' }} >
                                                <strong>
                                                  <a target="_blank" href={dados_config.current.content[0].contacts.link.includes('http') ? dados_config.current.content[0].contacts.link : "https://" + dados_config.current.content[0].contacts.link } style={{ msoLineHeightRule: 'exactly', textDecoration: 'underline', color: '#333333', fontSize: '13px', lineHeight: '21px', fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'" }} >{dados_config.current.content[0].contacts.link}</a>
                                                </strong>
                                              </p>
                                            </td>
                                          </tr>
                                        :
                                          null
                                        }
                                        <tr style={{ borderCollapse: 'collapse' }}>
                                          <td align="center" style={{ padding: '0', margin: '0', paddingTop: '0', paddingBottom: '0', fontSize: '0' }} >
                                            <table cellSpacing="0" cellPadding="0" className="es-table-not-adapt es-social" role="presentation" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }}>
                                              <tbody>
                                                <tr style={{ borderCollapse: 'collapse' }}>
                                                  {
                                                  dados_config.current.content[0].social !== undefined && dados_config.current.content[0].social !== null ?
                                                    dados_config.current.content[0].social.map((el_s, k_s) => {
                                                      if(el_s.info.link !== '') {
                                                        return (
                                                          <td key={k_s} valign="top" align="center" style={{ padding:'0', margin: '0', paddingLeft: '0', paddingRight: '0' }}>
                                                            <a href={compose_link_nl(dados_config.current.info.uniqid, 'sn', k_s, '*')} target="_blank" style={{ msoLineHeightRule: 'exactly', textDecoration: 'underline', color: '#333333', fontSize: '23px' }} >
                                                              <img width='34' src={repo_img_link(el_s.info.icon.bi + '.png')} style={{width: '34px'}} />
                                                            </a>
                                                          </td>
                                                        )
                                                      } else {
                                                        return null
                                                      }
                                                    })
                                                  :
                                                    null
                                                  }
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding="0" cellSpacing="0" align="center" className="es-footer" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', width: '100%', tableLayout: 'fixed !important', backgroundColor: 'transparent', backgroundRepeat: 'repeat', backgroundPosition: 'center top' }} >
              <tbody>
                <tr style={{ borderCollapse: 'collapse' }}>
                  <td align="center" bgcolor="#efefef" style={{padding: '0', margin: '0', backgroundColor: '#efefef' }} >
                    <table align="center" bgcolor="#333333" cellSpacing="0" cellPadding="0" className="es-footer-body" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', backgroundColor: '#333333', width: '600px' }} role="none">
                      <tbody>
                        <tr style={{ borderCollapse: 'collapse' }}>
                          <td style={{ padding: '15px', margin: '0' }}>
                            <table width="100%" cellSpacing="0" cellPadding="0" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }}>
                              <tbody>
                                <tr style={{ borderCollapse: 'collapse' }}>
                                  <td valign="top" align="center" style={{ padding: '0', margin: '0', width: '590px' }} >
                                    <table width="100%" cellSpacing="0" cellPadding="0" role="presentation" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }}>
                                      <tbody>
                                        <tr style={{ borderCollapse: 'collapse' }}>
                                          <td align="center" className="es-text-4627" style={{ padding: '0', margin: '0', paddingTop: '10px', paddingBottom: '10px' }}>
                                            <h6 className="es-text-mobile-size-12" style={{ margin: '0', fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'", msoLineHeightRule: 'exactly', letterSpacing: '0', fontSize: '12px', fontStyle: 'normal', fontWeight: 'normal', lineHeight: '18px', color: '#ffffff' }} >
                                              {language[lang].nl_recebeu} {translate(dados_config.current.content[0].company, 'pt')} <br />
                                              {language[lang].nl_cancelar} 
                                              <a target="_blank" href={compose_link_nl(dados_config.current.info.uniqid, 'un', 0, '*')} style={{ msoLineH0eightRule: 'exactly', textDecoration: 'underline', color: '#ffffff', fontSize: '12px', lineHeight: '18px', fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'" }} >
                                                {language[lang].nl_clique_aqui}
                                              </a>.
                                            </h6>
                                          </td>
                                        </tr>
                                        <tr style={{ borderCollapse: 'collapse' }}>
                                          <td align="center" className="es-text-9389" style={{ padding: '0', margin: '0' }}>
                                            <h6 className="es-text-mobile-size-12" style={{ margin: '0', fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'", msoLineHeightRule: 'exactly', letterSpacing: '0', fontSize: '12px', fontStyle: 'normal', fontWeight: 'normal', lineHeight: '18px', color: '#ffffff' }} >
                                              © 2025 {translate(dados_config.current.content[0].company, 'pt')} | {language[lang].nl_rights}
                                              <br />
                                              {parse(language[lang].nl_developed)} <a href="https://sim.assec.pt" target="_blank" style={{ msoLineH0eightRule: 'exactly', textDecoration: 'underline', color: '#ffffff', fontSize: '12px', lineHeight: '18px', fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'" }}>Assec Sim!</a>
                                            </h6>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>


};
export default Footer;